import request from "@/common/request"
import { Page, RegraDeInadimplencia } from "@/models"
import { AxiosRequestConfig } from "axios"

const basePath = '/inadimplencia'

export const findPageRegrasDeInadimplencia = (params?: any, config?: AxiosRequestConfig): Promise<Page<RegraDeInadimplencia>> =>
	request.get(`${basePath}/busca`, {params, ...config})

export const criarRegraDeInadimplencia = (regraDeInadimplencia: RegraDeInadimplencia): Promise<RegraDeInadimplencia> =>
	request.post(`${basePath}/criar`, regraDeInadimplencia)

export const atualizarRegraDeInadimplencia = (regraDeInadimplencia: RegraDeInadimplencia): Promise<RegraDeInadimplencia> =>
	request.post(`${basePath}/atualizar/${regraDeInadimplencia.id}`, regraDeInadimplencia)